import { VERSION_STATUS } from "./constants";

const CV = "Creative View";
const DT = "Decision Tree";

export const importExportVersionsAllowables = [
	{
		domain: CV,
		action: "Import Versions",
	},
	{
		domain: CV,
		action: "Export Versions",
	}
];

export const dtreeDropdownAllowables = [
	{
		domain: DT,
		action: "Create Decision Tree",
	},
	{
		domain: DT,
		action: "Assign Decision Tree",
	},
	{
		domain: DT,
		action: "Edit Decision Tree",
	}
];

export function canDeleteVersion(version){
	/*
		Versions can only be deleted if they're not currently in use, where "in use" means (status === "Live"),
		and if they're not the default version
	*/
	const { status, name } = version;
	return (status !== VERSION_STATUS.LIVE) && (name !== "default");
}

/**
 * Checks if selected versions can be deleted based on multiple criteria
 * and returns an array of the removable versions' id
 * We use Set.has() rather than prefiltering as it ~ has performance O(1)
 * for non-massive arrays
 * @param {number[]} selectedIds
 * @param {CreativeVersion[]} versions
 * @returns {number[]} removeableIds
 */
export const getRemovableSelectedVersions = (selectedIds, versions) => {
	const ids = new Set(selectedIds);

	// If nothing is selected, then there's nothing to delete (prevents redundant loop)
	if(!ids.size || !versions.length) {
		return [];
	}

	return versions.filter(item => ids.has(item.id) && canDeleteVersion(item)).map(item => item.id);
};
